<div class="check">
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="!checked"
  >
    <path
      d="M17.1255 7.32161C17.5543 6.8928 18.2496 6.8928 18.6784 7.32161C19.1072 7.75042 19.1072 8.44566 18.6784 8.87447L11.2666 16.2862C10.8378 16.715 10.1426 16.715 9.71377 16.2862L5.32161 11.8941C4.8928 11.4653 4.8928 10.77 5.32161 10.3412C5.75042 9.9124 6.44566 9.9124 6.87447 10.3412L10.4902 13.9569L17.1255 7.32161Z"
      fill="#E2E7ED"
    />
  </svg>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    *ngIf="checked"
  >
    <path
      d="M17.1255 7.32161C17.5543 6.8928 18.2496 6.8928 18.6784 7.32161C19.1072 7.75042 19.1072 8.44566 18.6784 8.87447L11.2666 16.2862C10.8378 16.715 10.1426 16.715 9.71377 16.2862L5.32161 11.8941C4.8928 11.4653 4.8928 10.77 5.32161 10.3412C5.75042 9.9124 6.44566 9.9124 6.87447 10.3412L10.4902 13.9569L17.1255 7.32161Z"
      fill="#14E25A"
    />
  </svg>
  <span class="check-text">{{ text }}</span>
</div>
